// The DEVELOPER's verdict on one case, shown read-only on the tester's side.
//
// This is how a tester sees "a developer says they fixed this" without the
// agent's own result being overwritten — the two live side by side. A case
// awaiting verification is what the next Re-run picks up.
import { CheckCircle2, XCircle, Ban, Clock, MessageSquare } from "lucide-react";
import { cn } from "@/lib/cn";

const DEV_BADGE = {
  passed: { cls: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300", Icon: CheckCircle2 },
  failed: { cls: "bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300", Icon: XCircle },
  blocked: { cls: "bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300", Icon: Ban },
};

const VERIFY_HINT = {
  awaiting_rerun: { label: "awaiting re-run", cls: "text-brand-600 dark:text-brand-300", Icon: Clock },
  verified: { label: "verified", cls: "text-emerald-600 dark:text-emerald-400", Icon: CheckCircle2 },
  still_failing: { label: "still failing", cls: "text-rose-600 dark:text-rose-400", Icon: XCircle },
};

export default function DevStatusCell({ item }) {
  if (!item?.dev_status) {
    return <span className="text-[0.6875rem] text-slate-300 dark:text-slate-600">—</span>;
  }
  const b = DEV_BADGE[item.dev_status] || DEV_BADGE.blocked;
  const v = VERIFY_HINT[item.dev_verify_state];
  return (
    <div className="min-w-0">
      <span
        className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[0.6875rem] font-semibold capitalize", b.cls)}
        title={item.dev_note || `Developer marked this ${item.dev_status}`}
      >
        <b.Icon size={10} /> {item.dev_status}
      </span>
      {v && (
        <span className={cn("mt-0.5 flex items-center gap-1 text-[0.625rem]", v.cls)}>
          <v.Icon size={9} /> {v.label}
        </span>
      )}
      {item.dev_note && (
        <span className="mt-0.5 flex items-start gap-1 truncate text-[0.625rem] text-slate-400" title={item.dev_note}>
          <MessageSquare size={9} className="mt-0.5 shrink-0" /> {item.dev_note}
        </span>
      )}
    </div>
  );
}
